import * as React from "react";
import { Component } from "react";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { Button, ButtonColorSchemes, ButtonProps } from "../buttons";
import { WithDisableTimerButton } from "../buttons/WithDisableTimerButton";
import { withLoadingOnAction } from "../buttons/withLoadingOnAction";
import { Indent } from "../indent";
import { ConfirmationWrapper, ConfirmationWrapperProps } from "./ConfirmationWrapper";

export const ButtonWithLoading = withLoadingOnAction(Button);
export const DisableTimerButton = WithDisableTimerButton(ButtonWithLoading);

export type ConfirmationProps = ConfirmationWrapperProps & {
    save?: () => void;
    saveBtnText?: string;
    cancelBtnText?: string;
    disableDelay?: number;
    isPositiveTheme?: boolean;
    auditSaveEvent?: ButtonProps["auditEvent"];
    cancelRefCallback?: F1<React.RefObject<HTMLSpanElement>, void>;
};

export class Confirmation extends Component<ConfirmationProps> {
    constructor(props: ConfirmationProps) {
        super(props);
    }

    saveButton = () => {
        const { save, saveBtnText, isPositiveTheme } = this.props;

        const btnProps: ButtonProps = {
            autoFocus: true,
            action: save,
            colorScheme: isPositiveTheme ? ButtonColorSchemes.Positive : ButtonColorSchemes.Danger,
            text: saveBtnText,
            auditEvent: this.props.auditSaveEvent,
        };

        return (
            <>
                {this.props.disableDelay > 0 ? (
                    <DisableTimerButton {...btnProps} disableDelay={this.props.disableDelay} />
                ) : (
                    <ButtonWithLoading {...btnProps} />
                )}
                <Indent />
            </>
        );
    };

    cancelRef = (ref: React.RefObject<HTMLSpanElement>) => {
        if (this.props.cancelRefCallback) {
            this.props.cancelRefCallback(ref);
        }
    };

    render() {
        const { save, cancel, cancelBtnText = commonClientResx.Cancel, hideCancelButton } = this.props;

        return (
            <ConfirmationWrapper {...this.props}>
                {save && this.saveButton()}
                {cancel && !hideCancelButton && (
                    <Button autoFocus={!save} action={cancel} text={cancelBtnText} refCallback={this.cancelRef} />
                )}
            </ConfirmationWrapper>
        );
    }
}
